<template>
  <div class="bootcamp-tile-results">
    <div
      class="bootcamp-tile-results__current"
      v-if="current && current.length"
    >
      <h3 class="bootcamp-tile-results__title">
        Current Bootcamps
      </h3>
      <div
        v-for="item in current"
        :key="item.objectID"
        class="bootcamp-tile-results__item"
      >
        <BootcampTile
          v-bind="{
            bootcamp: item,
            formatDate,
            renderMarkdown,
            epoch: true,
          }"
        />
      </div>
    </div>
    <div
      class="bootcamp-tile-results__upcoming"
      v-if="upcoming && upcoming.length"
    >
      <h3 class="bootcamp-tile-results__title">
        Upcoming Bootcamps
      </h3>
      <div
        v-for="item in upcoming"
        :key="item.objectID"
        class="bootcamp-tile-results__item"
      >
        <BootcampTile
          v-bind="{
            bootcamp: item,
            formatDate,
            renderMarkdown,
            epoch: true,
          }"
        />
      </div>
    </div>
    <div class="bootcamp-tile-results__past" v-if="past && past.length">
      <h3 class="bootcamp-tile-results__title">
        Previous Bootcamps
      </h3>
      <div class="bootcamp-tile-results__past">
        <div
          v-for="item in past"
          :key="item.objectID"
          class="bootcamp-tile-results__item"
        >
          <BootcampTile
            v-bind="{
              bootcamp: item,
              formatDate,
              renderMarkdown,
              epoch: true,
            }"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { compareAsc } from 'date-fns'
import { formatDateForBootcamp } from '@/helpers'
import BootcampTile from '@/components/layout/BootcampTile.vue'

const marked = require('marked')

export default {
  name: 'BootcampListResults',
  components: {
    BootcampTile,
  },
  props: {
    // should be all the bootcamps, no pagination in favor of grouping
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    current() {
      return this.items.filter(b => {
        return (
          compareAsc(new Date(b.start_datetime * 1000), new Date()) < 0 &&
          compareAsc(new Date(b.end_datetime * 1000), new Date()) >= 0
        )
      })
    },
    upcoming() {
      return this.items.filter(b => {
        return compareAsc(new Date(b.start_datetime * 1000), new Date()) > 0
      })
    },
    past() {
      return this.items.filter(b => {
        return compareAsc(new Date(b.end_datetime * 1000), new Date()) <= 0
      })
    },
  },
  methods: {
    renderMarkdown(string) {
      return marked(string)
    },
    formatDate(start, end, epoch) {
      return formatDateForBootcamp(start, end, epoch)
    },
  },
}
</script>

<style lang="scss" scoped>
.bootcamp-tile-results {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
  &__item {
    width: 100%;
    margin: 0 0 20px 0;
    padding: 0;
    min-height: 350px;
    @include tablet {
      width: 50%;
    }
    @include desktop {
      width: calc(50% - 15px);
      max-width: 650px;
    }
  }
  &__title {
    color: var(--white);
    font-size: rem(20px);
    font-weight: bold;
    margin: 0 15px;
    width: 100%;
  }
  &__upcoming,
  &__past,
  &__current {
    padding: 15px;
    margin-bottom: 15px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: space-between;
  }
}
</style>
